var handle_array = ["2020-upper-deck-goodwin-champions-personal-box-dm-us-for-pricing","2020-upper-deck-goodwin-champions-personal-box-dm-us-for-pricing-1","click-call-for-price-button-and-message-us-for-price-2019-20-upper-deck-chronology-volume-2-hockey-hobby-box","click-call-for-price-button-and-message-us-for-price-2020-21-upper-deck-artifacts-hockey-hobby-personal-box"];
 var hide_price=1;
 var hide_ajaxaddtocart=1;
 var display_phone=0;
 var phone_no = '';
 var display_call_for_price = 1;
 var call_for_price_label = 'Call for Price';
 var css_style_button='background-color: #000000;color:#ffffff;';
 var enabled_captcha = 0;
 var site_key = '';
 var thankyou_msg = 'Your Request Submitted Successfully.';
 var thankyou_header = 'Success';
 var name_label='Name';
 var email_label='Email';
 var phone_label = ' Phone Number';
 var comment_label = 'Comment';
 var submit_label ='Submit';
  var error_name_label='Please fill out this field.';
 var error_email_label='Please fill out this field.';
 var error_phone_label = 'Please fill out this field.';
 var error_comment_label = 'Please fill out this field.';
 var enable_app =1;
  var enable_outofstock = 1;
 var price_selector='';
 var cart_selector='#AddToCart-product-template';
 var phone_no_label = 'DM US FOR PRICE';
 var required_field='name,email,comment';
 var contact_form_heading='Call for Price for';
 var parent_selector='';
 var unavailable_label='Unavailable';
